import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b2562a5c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "navbar navbar-expand-sm navbar-dark bg-primary" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "navbar-brand" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/img/logo.png",
    alt: "ACT Property"
  })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarSupportedContent",
  "aria-controls": "navbarSupportedContent",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1))
const _hoisted_5 = {
  key: 0,
  class: "collapse navbar-collapse",
  id: "navbarSupportedContent"
}
const _hoisted_6 = {
  key: 0,
  class: "navbar-nav mr-auto"
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  key: 0,
  class: "btn-group"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline dropdown-toggle nav-link",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Diary ", -1))
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_12 = {
  key: 2,
  class: "nav-item"
}
const _hoisted_13 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_14 = {
  key: 4,
  class: "btn-group"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline dropdown-toggle nav-link",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Dictionary ", -1))
const _hoisted_16 = { class: "dropdown-menu" }
const _hoisted_17 = {
  key: 5,
  class: "btn-group"
}
const _hoisted_18 = {
  key: 6,
  class: "btn-group"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline dropdown-toggle nav-link",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Designers ", -1))
const _hoisted_20 = { class: "dropdown-menu" }
const _hoisted_21 = {
  key: 7,
  class: "btn-group"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-outline dropdown-toggle nav-link",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, " Templates ", -1))
const _hoisted_23 = { class: "dropdown-menu" }
const _hoisted_24 = {
  key: 8,
  class: "nav-item"
}
const _hoisted_25 = {
  key: 9,
  class: "nav-item"
}
const _hoisted_26 = {
  key: 1,
  class: "navbar-nav mr-auto"
}
const _hoisted_27 = { class: "nav-item" }
const _hoisted_28 = { class: "navbar-nav ml-auto" }
const _hoisted_29 = { class: "nav-item" }
const _hoisted_30 = { class: "nav-link text-light" }
const _hoisted_31 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_32 = { class: "nav-link text-light" }
const _hoisted_33 = { class: "nav-item" }

import { computed, inject, onMounted, onBeforeUnmount, onUnmounted, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import Auth from "@aws-amplify/auth";
import { useStore } from 'vuex';
import moment from "moment-timezone";
import { useToast } from "vue-toastification";
import { Office, Dictionary, DictionaryReportType } from "@/models";
import Ably from "ably";


export default /*#__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const route = useRoute();
const router = useRouter();

// State, Getters, Mutations, and Actions from Vuex
const store = useStore();
const email = computed(() => store.getters['auth/email']);
const isAdministrator = computed(() => store.getters['auth/isAdministrator']);
const isSysAdmin = computed(() => store.getters['auth/isSysAdmin']);
const isCustomer = computed(() => store.getters['auth/isCustomer']);
const isDataentry = computed(() => store.getters['auth/isDataentry']);
const isDiaryUser = computed(() => store.getters['auth/isDiaryUser']);
const isQCUser = computed(() => store.getters['auth/isQCUser']);
const isBookingManagement = computed(() => store.getters['auth/isBookingManagement']);
const signedIn = computed(() => store.getters['auth/signedIn']);
const isBooking = computed(() => store.getters['auth/isBooking']);
const currentOffice = computed((): Office => store.getters['offices/currentOffice']);
const dictionary = computed((): Dictionary => store.getters['dictionary/current']);
const reportsState = computed(() => store.state.reports);

const isMobileDiaryUser = computed(() => screen.width <= 760 && isDiaryUser);

// Injects
const realtime: Ably.Realtime = inject('realtime');
const actProperty: any = inject('actProperty');

// Refs
const diaryFormOpenConfirm = ref(false);
const channel: Ably.Types.RealtimeChannelCallbacks = realtime.channels.get('diary');
const deviceid = actProperty.getDeviceId();

// Functions converted to Composition API style
const setCognitoUser = (user: any) => store.commit('auth/setCognitoUser', user);

const signOut = async () => {
  try {
    router.push({ name: "home" });
    if (
      !store.getters["customers/hasUnsavedChanges"] &&
      !store.getters["dictionary/hasUnsavedChanges"] &&
      !store.getters["reports/hasUnsavedChanges"]
    ) {
      await Auth.signOut();
      setCognitoUser(null);
      router.push({ name: "sign-in" });
    }
  } catch (err: any) {
    actProperty.displayError(err);
  }
};

const getReportsUrl = () => {
  let url = isDataentry.value ? "/dereports" : "/reports";
  if (reportsState.value.month) {
    url += `?month=${encodeURIComponent(reportsState.value.month)}`;
  } else if (reportsState.value.search) {
    url += `?search=${encodeURIComponent(reportsState.value.search)}`;
  }
  return url;
};

const reporttypeswithdictionary = computed(() => {
  return dictionary.value?.reporttypes?.filter((t) => t.dictionaryflag === true);
});

const openCalendarInNewTab = () => {
  window.open("/scheduler/" + moment().format("DD-MM-YYYY"));
};

const openDiaryFormInNewTab = () => {
  diaryFormOpenConfirm.value = false;
  channel.publish('diaryFormOpenCheck', { deviceid: deviceid });
  setTimeout(() => {
    if (!diaryFormOpenConfirm.value) window.open("/diary");
  }, 1000);
};

const isOnDiaryPages = () => {
  return route.fullPath.includes('diary') || route.fullPath.includes('scheduler');
};

const openReportsPage = () => {
  window.open("/reports");
};

onMounted(() => {
  channel.subscribe('diaryFormOpenConfirm', (message: any) => {
    if (message.data.deviceid != deviceid) return;
    diaryFormOpenConfirm.value = true;
  });
});

onBeforeUnmount(() => {
  channel.unsubscribe('diaryFormOpenConfirm');
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      (signedIn.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (isSysAdmin.value || isAdministrator.value || isCustomer.value)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                  _createElementVNode("li", _hoisted_7, [
                    (isOnDiaryPages())
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "nav-link",
                          style: {"cursor":"pointer"},
                          onClick: openReportsPage
                        }, "Reports"))
                      : (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          class: "nav-link",
                          to: getReportsUrl()
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Reports")
                          ]),
                          _: 1
                        }, 8, ["to"]))
                  ]),
                  (isBooking.value || isQCUser.value || isBookingManagement.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", {
                            class: "dropdown-item",
                            style: {"cursor":"pointer"},
                            onClick: openCalendarInNewTab
                          }, "Diary"),
                          _createElementVNode("div", {
                            class: "dropdown-item",
                            style: {"cursor":"pointer"},
                            onClick: openDiaryFormInNewTab
                          }, "Booking Form"),
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/diarymanagementfilters"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Management Filters")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (isAdministrator.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: "/propertyvisitmanagements"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("PV Managements")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (isAdministrator.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: "/customerlist"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Customers")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (isAdministrator.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: "/inspectorlist"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Inspectors")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (isSysAdmin.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_14, [
                        _hoisted_15,
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/dictionary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Dictionary")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/conversionmatrix"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Conversion Matrix")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : (isAdministrator.value)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                          _createVNode(_component_router_link, {
                            class: "nav-link",
                            to: "/dictionary"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Dictionary")
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                  (isAdministrator.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/customerdictionary/property visit"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Mid Term Designer")
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reporttypeswithdictionary.value, (reporttype) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              class: "dropdown-item",
                              key: reporttype.slug,
                              to: `/customerdictionary/${reporttype.slug}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(reporttype.displayname) + " Designer", 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (isAdministrator.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _hoisted_22,
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/emailtemplates"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("Email Templates")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_router_link, {
                            class: "dropdown-item",
                            to: "/smstemplates"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("SMS Templates")
                            ]),
                            _: 1
                          })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (isSysAdmin.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: "/remotesupport"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Remote Support")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (isSysAdmin.value)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_25, [
                        _createVNode(_component_router_link, {
                          class: "nav-link",
                          to: "/sysadmin"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("System Admin")
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (isDataentry.value && !isMobileDiaryUser.value)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_26, [
                  _createElementVNode("li", _hoisted_27, [
                    _createVNode(_component_router_link, {
                      class: "nav-link",
                      to: getReportsUrl()
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Reports")
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("ul", _hoisted_28, [
              _createElementVNode("li", _hoisted_29, [
                _createElementVNode("span", _hoisted_30, _toDisplayString(email.value), 1)
              ]),
              (currentOffice.value)
                ? (_openBlock(), _createElementBlock("li", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(currentOffice.value.name), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("li", _hoisted_33, [
                _createElementVNode("a", {
                  class: "nav-link",
                  href: "/sign-out",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (signOut()), ["prevent"]))
                }, " Sign out ")
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})